export default __webpack_public_path__ + "static/media/04.e7851667.jpeg";